import api from './api';

const endpoint = '/api/v1/locations/';

export default {
    async get(searchTerm, radius, isPassport) {
        /**
         * Sending city and zip to API duplicated to not affect other API usages in the future
         * and/or give independent control of this API.
         */
        return api.post(endpoint, {
            zipcode: searchTerm,
            radius: radius,
            city: searchTerm,
            is_passport: isPassport
        });
    },
}
